/**
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Logger from './lib/logger';
import ConfigureBundleStep1 from './partials/ConfigureBundleStep1';
import HowItWorksModal from './partials/HowItWorksModal'; // custom element
import ConfiguratorIntersectionalObserver from './partials/ConfiguratorIntersectionalObserver'; // custom element

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Page Configure Bundle Step 1';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
  Logger.info(`${NAME} > init`);
  ConfigureBundleStep1();
}

Logger.info(`${NAME} > loaded`);

// Bootstrap page-specific functionality
init();
